module.exports = __webpack_public_path__ + "img/RGD-9001.dbf745ff.webp";